import Box from '@mui/material/Box';

export const PieChartLegendTableRow = (props: any) => {
  return (
    <tr
      id={props.row.species}
      className={props.row.color ? '' : 'highlight-row legend-table-hidden-row'}
      style={{ display: props.row.color ? '' : 'none' }}
    >
      <td className="rect">
        {props.row.color ? (
          <div
            style={{
              background: props.row.color,
              width: '28px',
              height: '12px',
              borderRadius: '4px',
            }}
          ></div>
        ) : (
          ''
        )}
      </td>
      <td>
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'end',
          }}
        >
          {props.row.percentage}
        </Box>
      </td>
      <td>
        <Box
          sx={{
            display: 'flex',
            gap: '4px',
            paddingLeft: '38px',
            alignItems: 'center',
          }}
        >
          {props.row.species}
          {props.row.species === 'Other' ? (
            <i id="table-arrow" className="table-arrow down"></i>
          ) : (
            ''
          )}
        </Box>
      </td>
      <td
        style={{ display: 'flex', flexDirection: 'column', alignItems: 'end' }}
      >
        {props.row.count}
      </td>
    </tr>
  );
};
